import { stateKeys } from '../../types';

export const getServiceNowFeedbackUrl = (state) => state[stateKeys.FEEDBACK].serviceNowFeedbackUrl;
